/* @flow */
import * as React from "react";
import ReactDOM from "react-dom";

type DialogDestroyers = {
  [key: string]: {
    destroyRoot: () => void,
  },
};
const dialogDestroyers: DialogDestroyers = {};
let nextId = 0;

export function closeDialog(key: string) {
  if (key in dialogDestroyers) {
    dialogDestroyers[key].destroyRoot();
    delete dialogDestroyers[key];
  } else {
    throw new Error(
      `Attempted to close a dialog with key '${key}' that does not exist`
    );
  }
}

export function closeAllDestroyableDialogs() {
  Object.keys(dialogDestroyers).forEach(closeDialog);
}

export default function renderInDestroyableRoot(
  renderCallback: (destroyRoot: () => void) => React.Element<*>,
  dialogKey?: string
) {
  const key = dialogKey || `${nextId++}`;
  const { body } = document;
  if (key in dialogDestroyers) {
    throw new Error(
      `Attempted to show a dialog with key '${key}' that already exists`
    );
  }
  if (body == null) {
    throw new Error(
      "Attempted to call renderInDestroyableRoot without a document.body"
    );
  }

  let el = document.createElement("div");
  body.appendChild(el);

  const destroyRoot = () => {
    if (!el) {
      return;
    }
    ReactDOM.unmountComponentAtNode(el);
    body.removeChild(el);
    el = null;
  };

  ReactDOM.render(renderCallback(destroyRoot), el);
  dialogDestroyers[key] = { destroyRoot };
}



// WEBPACK FOOTER //
// ./src/components/Dialogs/renderInDestroyableRoot.js